import formatTableJson from '@manage/config/tableComponentParams.js'

export default formatTableJson([
  {
    filed: 'title',
    label: '标题'
  },
  {
    filed: 'typeName',
    label: '类型'
  },
  {
    filed: 'picture',
    label: '图片',
    type: 'image',
    needPreviewImg: true
  },
  {
    filed: 'userName',
    label: '添加人'
  },
  {
    filed: 'createTime',
    label: '添加时间',
    type: 'time',
    width: '170'
  }
])
